if (window.__env) {
    window.commonApi = window.__env;
    window.commonApi.KNOWLEDGE_BOT_URL = location.origin;
    window.commonApi.SSO_SCOPE = "profile task task_edit process triple app openid data profile_edit stats submit process_edit sys_process_edit entrust entrust_edit",
    window.commonApi.TASKCENTER_URL = location.origin + window.commonApi.PATH;
    window.commonApi.varyTarget = "1";
    window.commonApi.TENANT = 'zufe.edu.cn';

} else {
    window.commonApi = {
        TASKCENTER_URL: "/taskcenter-v4-master",
        KNOWLEDGE_URL: "/bus/graphql/nBKkQfSGC8rsJl4HVIYn",
        TASKAPI_URL: "",
        INFOPLUS_URL: "/infoplus/apis/v2",
        SSO_BASE_URL: "https://cloud.ketanyun.cn/sso",
        BOT_URL: "/knowledge-bot",
        SSO_SCOPE: "profile task task_edit process introspect openid data triple app profile_edit stats submit process_edit sys_process_edit entrust entrust_edit",
        SSO_KEY: 'ByYCH5BkYokdjOh2rYns',
        PATH: "/taskcenter",
        KNOWLEDGE_BOT_URL: "",
        TENANT: 'cloud.ketanyun.cn',

        TRACE_URL: "/bus/graphql/trace",
        TASKCENTER_API_URL: '/taskcenter-api',

        APPCENTER_ANONYMITY_URL: `/appcenter/anonymity`,
        // BUS_URL: "/bus/graphql/ByYCH5BkYokdjOh2rYns",

        APPCENTER_URL: "/bus/graphql/appcenter",
        BUS_URL:'/bus/graphql/builtin',
        varyTarget: "ALL"
    }
}
let redirect_uri = encodeURIComponent(window.location.href);
let client_id = window.commonApi.SSO_KEY;
let scope = window.commonApi.SSO_SCOPE;
let authority = window.commonApi.SSO_BASE_URL + "/oauth2";
export const oidcSettings = {
    authority: authority,
    metadata: {
        issuer: authority,
        authorization_endpoint: authority + "/authorize",
        userinfo_endpoint: authority + "/userinfo",
        end_session_endpoint: window.commonApi.SSO_BASE_URL + "/logout?redirect_uri=" + redirect_uri,
        jwks_uri: authority + "/jwks.json"
    },
    clientId: client_id,
    redirectUri: window.location.origin + window.commonApi.PATH + "/workflow/oidcCallback",
    responseType: "id_token token",
    scope: scope,

    // automaticSilentRenew: true,
    // automaticSilentSignin: false,
    // silentRedirectUri: window.location.origin + window.commonApi.PATH + "/workflow/oidcRenew",
    // silentRequestTimeout: 3 * 1000

};



// WEBPACK FOOTER //
// ./src/store/config/oidc.js